
  <div class="day-wrapper" [style.background]="setor?.cor ?? '#c4c4c4'">
    <ng-container *ngIf="setor">
      <p>{{ dataTroca | date: 'EEEEEE' | uppercase}}</p>
      <span>{{ dataTroca | date: 'dd' | uppercase}}</span>
    </ng-container>

  </div>

  <ion-avatar *ngIf="colaborador" >
    <img
      alt="Silhouette of a person's head" src="https://ionicframework.com/docs/img/demos/avatar.svg"
    />
  </ion-avatar>

  <div class="notPicture" *ngIf="!colaborador">

  </div>

  <ion-label>
    <h3 *ngIf="colaborador">{{ colaborador.nome }}</h3>
    <ng-container *ngIf="turno || setor">
      <ion-chip *ngIf="turno" [style.background]="turno.cor">{{ turno.sigla | uppercase}} - {{ turno.horaInicio }} a {{ turno.horaFim }}</ion-chip>
      <ion-chip *ngIf="setor" [style.background]="setor.cor">{{ setor.nome | uppercase }}</ion-chip>
    </ng-container>
  </ion-label>
